export enum JewelryType {
  Ring = 'single',
  Pendant = 'pendant',
  Earring = 'pair',
  Bracelet = 'bracelet'
}
